export const deleteVendorAccount = (builder) => ({
    deleteVendorAccount: builder.mutation({
      query: (body) => {
        const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
  
        return {
          url: '/delete-vendor',
          method: 'DELETE',
          body: body,
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token
          },
        };
      },
    }),
  });
  
  